<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
            <p-image src="../assets/images/Cardio4Cities_Accelerator_logo.svg" alt="" width="120"
                styleClass="custom-image"></p-image>
        </a>
    </div>

    <div class="layout-topbar-actions sm:pr-5">
        @if (showDiseaseDropdown) {
        <app-disease-dropdown class="xs:hidden sm:block"></app-disease-dropdown>
        }
        @if (showLocationDropdown) {
        <app-location-dropdown></app-location-dropdown>
        }

        <div class="layout-config-menu" style="display: none">
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i
                    [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button>
            <div class="relative">
                <button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next"
                    enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>
        <button *ngIf="showGenerateButton" type="button" (click)="openLanguageDialog()"
            class="inline-flex generateButton items-center gap-2 rounded-full px-4 py-2 bg-white">
            <span class="relative inline-flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                        d="M2 0.200195H10.7998V1.7998H1.7998V16.2002H16.2002V7.2002H17.7998V16C17.7998 16.4965 17.6259 16.917 17.2715 17.2715C16.917 17.6259 16.4965 17.7998 16 17.7998H2C1.50346 17.7998 1.08297 17.6259 0.728516 17.2715C0.374057 16.917 0.200195 16.4965 0.200195 16V2C0.200195 1.50347 0.374057 1.08297 0.728516 0.728516C1.08297 0.374057 1.50347 0.200195 2 0.200195ZM12.7998 12.2002V13.7998H5.2002V12.2002H12.7998ZM12.7998 9.2002V10.7998H5.2002V9.2002H12.7998ZM12.7998 6.2002V7.7998H5.2002V6.2002H12.7998ZM15.7998 0.200195V2.2002H17.7998V3.7998H15.7998V5.7998H14.2002V3.7998H12.2002V2.2002H14.2002V0.200195H15.7998Z"
                        fill="url(#paint0_linear_7423_4771)" stroke="white" stroke-width="0.4" />
                    <defs>
                        <linearGradient id="paint0_linear_7423_4771" x1="0" y1="9" x2="18" y2="9"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#005595" />
                            <stop offset="1" stop-color="#DA366F" />
                        </linearGradient>
                    </defs>
                </svg>
            </span>
            <span class="text-sm font-semibold bg-gradient-to-r from-sky-600 to-pink-600 bg-clip-text text-transparent">
                Generate Report
            </span>
        </button>

        <!-- Profile dropdown trigger -->
        <button #profileBtn class="inline-flex items-center gap-2 px-3 py-2 rounded-full hover:bg-surface-100"
            type="button" (click)="profilePanel.toggle($event, profileBtn)">
            <i class="pi pi-user"></i>
            <span class="text-sm font-medium xs:hidden sm:block">Hi {{ userName || userEmail || 'Guest' }}</span>
            <i class="pi pi-angle-down text-sm"></i>
        </button>

        <!-- Overlay Panel Dropdown -->
        <p-popover #profilePanel appendTo="body" [style]="{ width: '200px' }">
            <div>
                <!-- Header -->
                <div class="flex items-center gap-3 p-4">
                    <i class="pi pi-user"></i>
                    <div class="flex-1">
                        <div class="flex items-center gap-2">
                            <span class="font-semibold"> {{ userName || userEmail || 'Guest' }} </span>
                        </div>
                        <!-- Email with ellipsis + tooltip -->
                        <div class="text-xs text-gray-500 email-ellipsis" [title]="userEmail">{{ userEmail }}</div>
                        <div class="text-xs text-gray-500" *ngIf="userLevel">Access: {{ userLevel }}</div>
                    </div>
                </div>

                <!-- Menu rows -->
                @if (isAdminUser) {
                 <div class="flex flex-col">
                    <button class="flex items-center gap-3 px-4 py-3 hover:bg-surface-100 text-left"
                        (click)="openAdminDashboard()"><i class="pi pi-shield"></i><span>Admin</span></button>
                </div>
                }

                <div class="border-t border-surface-200"></div>

                <button class="flex items-center gap-3 px-4 py-3 hover:bg-surface-100 text-left w-full"
                    (click)="logout(); profilePanel.hide()"><i class="pi pi-sign-out"></i><span>Log Out</span></button>
            </div>
        </p-popover>

        <!-- <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden"
    enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
    [hideOnOutsideClick]="true">
    <i class="pi pi-ellipsis-v"></i>
  </button> -->
    </div>
</div>

<p-dialog header="Information" [modal]="true" [(visible)]="infoDialogVisible" [style]="{ width: '24rem' }">
    <div class="text-sm text-slate-700">To generate a report, please add at least one new simulation beyond the Basic
        Simulation.</div>
    <div class="flex justify-end gap-2 mt-3">
        <p-button label="OK" (click)="infoDialogVisible = false" />
    </div>
</p-dialog>
<!-- Language selection dialog (unchanged) -->
<p-dialog header="Select language" [modal]="true" [(visible)]="languageDialogVisible" [style]="{ width: '22rem' }">
    <div class="mb-4">
        <p-select [options]="languageOptions" [(ngModel)]="selectedLanguage" optionLabel="label" optionValue="value"
            placeholder="Choose language" styleClass="w-full"> </p-select>
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="languageDialogVisible = false" />
        <p-button label="Generate" class="mb-4" (click)="confirmGenerate()" />
    </div>
</p-dialog>